{
  "name": "@zimic/http",
  "description": "Next-gen TypeScript-first HTTP utilities",
  "keywords": [
    "zimic",
    "typescript",
    "types",
    "typegen",
    "validation",
    "inference",
    "http",
    "api",
    "static"
  ],
  "version": "1.4.1",
  "homepage": "https://zimic.dev/docs/http",
  "repository": {
    "type": "git",
    "url": "https://github.com/zimicjs/zimic.git",
    "directory": "packages/zimic-http"
  },
  "author": {
    "name": "Diego Aquino",
    "url": "https://github.com/diego-aquino"
  },
  "funding": {
    "type": "github",
    "url": "https://github.com/sponsors/zimicjs"
  },
  "private": false,
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "engines": {
    "node": ">=22.0.0"
  },
  "license": "MIT",
  "files": [
    "package.json",
    "README.md",
    "LICENSE.md",
    "src",
    "!src/**/tests",
    "!src/**/__tests__",
    "!src/**/*.test.ts",
    "bin",
    "dist",
    "index.d.ts",
    "typegen.d.ts"
  ],
  "sideEffects": false,
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "index.d.ts",
  "bin": {
    "zimic-http": "./bin/zimic-http.js"
  },
  "exports": {
    ".": {
      "types": "./index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "default": "./dist/index.js"
    },
    "./typegen": {
      "types": "./typegen.d.ts",
      "import": "./dist/typegen.mjs",
      "require": "./dist/typegen.js",
      "default": "./dist/typegen.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "setup": "playwright install chromium",
    "dev": "tsup --watch",
    "cli": "node --enable-source-maps ./dist/cli.js",
    "build": "tsup",
    "lint": "eslint --cache --no-error-on-unmatched-pattern --no-warn-ignored --fix",
    "lint:turbo": "pnpm lint . --max-warnings 0",
    "style": "prettier --log-level warn --ignore-unknown --no-error-on-unmatched-pattern --cache",
    "style:check": "pnpm style --check",
    "style:format": "pnpm style --write",
    "test": "dotenv -v NODE_ENV=test -v FORCE_COLOR=1 -- vitest",
    "test:turbo": "dotenv -v CI=true -- pnpm run test --coverage --reporter verbose",
    "types:check": "tsc --noEmit",
    "typegen:fixtures": "tsx ./scripts/typegen/generateFixtureTypes.ts"
  },
  "dependencies": {
    "openapi-typescript": "7.13.0",
    "picocolors": "^1.1.1",
    "yargs": "18.1.0"
  },
  "devDependencies": {
    "@types/js-yaml": "^4.0.9",
    "@types/node": "^26.1.2",
    "@types/yargs": "^17.0.35",
    "@typescript/native": "npm:typescript@^7.0.2",
    "@vitest/browser": "^4.1.10",
    "@vitest/browser-playwright": "^4.1.10",
    "@vitest/coverage-istanbul": "^4.1.10",
    "@zimic/eslint-config-node": "workspace:*",
    "@zimic/interceptor": "workspace:*",
    "@zimic/lint-staged-config": "workspace:*",
    "@zimic/tsconfig": "workspace:*",
    "@zimic/utils": "workspace:*",
    "dotenv-cli": "^11.0.0",
    "eslint": "^9.39.5",
    "js-yaml": "^5.2.3",
    "playwright": "^1.62.0",
    "prettier": "^3.9.6",
    "tsup": "^8.5.1",
    "tsx": "^4.23.1",
    "typescript": "npm:@typescript/typescript6@^6.0.2",
    "vitest": "^4.1.10"
  },
  "peerDependencies": {
    "typescript": "^5.0.0 || ^6.0.0 || ^7.0.0"
  },
  "peerDependenciesMeta": {
    "typescript": {
      "optional": true
    }
  }
}
